module.exports = __webpack_public_path__ + "img/中间bg1.9b82f2b3.png";